import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

function CTASection() {
  return (
    <section className="home-cta">
      <div className="cta-container">
        <h2 className="cta-heading">Ready to run trade shows that actually work?</h2>
        <p className="cta-subheading">
          Join teams using Zibit to plan smarter, execute better, and prove ROI.
        </p>
        <div className="cta-buttons">
          <Link to="/signup">
            <button className="cta-primary">Start Now</button>
          </Link>
          <Link to="/contact">
            <button className="cta-secondary">Talk to Us</button>
          </Link>
        </div>
       
      </div>
    </section>
  );
}

export default CTASection;